<div class="sidebar" data-color="azure" data-background-color="black" data-image="../../assets/img/sidebar-4.jpg">
  <!--
    Tip 1: You can change the color of the sidebar using: data-color="purple | azure | green | orange | danger"

    Tip 2: you can also add an image using data-image tag
-->
  <div class="logo">
    <!--<a href="javascript:void(0)" class="simple-text logo-mini">
      <img src="assets/images/upperlinklogo.jpg" width="10">
    </a>-->
    <a href="javascript:void(0)" class="simple-text logo-normal" style="padding-left: 24px">
      <img src="../../../../../assets/images/MwareCollegeDreamsWeb.png" width="150">
    </a>
  </div>
  <div class="sidebar-wrapper"  style="overflow-x: hidden">
    <div class="user">
      <div class="photo">
        <img src="../../../../../assets/images/MwareCollegeDreamsWeb.png" />
      </div>


      <!--<div class="user-info">
        <a data-toggle="collapse" href="#userInfo" class="username">
              <span *ngIf="currentUser">
                 {{currentUser?.firstName + " " + currentUser?.lastName}}
                <b class="caret"></b>
              </span>
        </a>
        <div class="collapse" id="userInfo">
          <ul class="nav">
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" [routerLink]="['change-password']">
                <span class="sidebar-mini"> CP </span>
                <span class="sidebar-normal">Change Password</span>
              </a>
            </li>
          </ul>
        </div>
      </div>-->
      <div class="user-info">
        <a class="username">
            <span *ngIf="currentUser">
                 {{currentUser?.first_name + " " + currentUser?.last_name}}
              <!--<b class="caret"></b>-->
            </span>
        </a>
      </div>
    </div>

    <!--<ul class="nav" *ngIf="userRole.toLowerCase() === 'admin'">-->
    <ul class="nav">
      <li class="nav-item active special-class" id="dashboard">
        <a class="nav-link" href="javascript:void(0)" [routerLink]="['/admin/dashboard']">
          <i class="material-icons">dashboard</i>
          <p> Dashboard </p>
        </a>
      </li>

      <li class="nav-item" id="manage-clients">
        <a class="nav-link" data-toggle="collapse" href="#manageClients">
          <i class="material-icons">people</i>
          <p> Manage Clients
            <b class="caret"></b>
          </p>
        </a>
        <div class="collapse" id="manageClients" >
          <ul class="nav">
            <li class="nav-item  special-class"  id="manage-users">
              <a class="nav-link" href="javascript:void(0)" [routerLink]="['/admin/manage-clients']">
                <span class="sidebar-mini"> AC </span>
                <span class="sidebar-normal">All Clients</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <li class="nav-item" id="manage-students">
        <a class="nav-link" data-toggle="collapse" href="#manageStudents">
          <i class="material-icons sidebar-mini">wc</i>
          <p class="sidebar-normal">Manage Students
            <b class="caret"></b>
          </p>
        </a>
        <div class="collapse" id="manageStudents" >
          <ul class="nav">
            <li class="nav-item  special-class"  id="students">
              <a class="nav-link" href="javascript:void(0)"
                 [routerLink]="['/admin/students']">
                <span class="sidebar-mini"> AS </span>
                <span class="sidebar-normal">All Students</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <li class="nav-item" id="manage-results">
        <a class="nav-link" data-toggle="collapse" href="#manageResults">
          <i class="material-icons sidebar-mini">description</i>
          <p class="sidebar-normal">Manage Results
            <b class="caret"></b>
          </p>
        </a>
        <div class="collapse" id="manageResults" >
          <ul class="nav">
            <li class="nav-item  special-class"  id="results">
              <a class="nav-link" href="javascript:void(0)"
                 [routerLink]="['/admin/results']">
                <span class="sidebar-mini"> AR </span>
                <span class="sidebar-normal">All Results</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <li class="nav-item" id="manage-epurse">
        <a class="nav-link" data-toggle="collapse" href="#manageEpurse">
          <i class="material-icons">compare_arrows</i>
          <p>E-Purse
            <b class="caret"></b>
          </p>
        </a>
        <div class="collapse" id="manageEpurse" >
          <ul class="nav">
            <li class="nav-item  special-class"  id="epursePayments">
              <a class="nav-link" href="javascript:void(0)"
                 [routerLink]="['/admin/epurse']">
                <span class="sidebar-mini"> PR </span>
                <span class="sidebar-normal">Payment Reports</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <li class="nav-item special-class" id="manage-reports">
        <a class="nav-link" href="javascript:void(0)" [routerLink]="['/admin/reports']">
          <i class="material-icons sidebar-mini">description</i>
          <span class="sidebar-normal">Manage Reports</span>
        </a>

      </li>

    </ul>

  </div>
</div>
